module.exports = __webpack_public_path__ + "img/user05.d17a23fa.jpg";